import { Font } from './useAgencyBranding';

export const LIGHTNESS_THRESHOLD = 0.4;

export const defaultMKColors = {
  '--media-kit-primary': 'var(--wb-color-orange-400)',
  '--media-kit-secondary': 'var(--wb-color-purple-600)',
  '--media-kit-tertiary': 'var(--wb-color-green-500)',

  '--media-kit-background-primary': 'var(--wb-color-neutral-0)',
  '--media-kit-background-secondary': 'var(--wb-color-neutral-0)',
  '--media-kit-background-alpha': 'var(--wb-color-neutral-100)',
  '--media-kit-background-skeleton': 'var(--wb-color-neutral-50)',

  '--media-kit-text-base': 'var(--wb-root-text-color-base)',
  '--media-kit-text-subtle': 'var(--wb-root-text-color-subtle)',

  '--media-kit-button-background-default':
    'var(--wb-action-primary-background-default)',
  '--media-kit-button-background-hover':
    'var(--wb-action-primary-background-hover)',
  '--media-kit-button-text': 'var(--wb-action-inverse-text)',

  '--media-kit-chart-background-primary': 'var(--media-kit-primary)',
  '--media-kit-chart-background-secondary': 'var(--media-kit-secondary)',
  '--media-kit-chart-background-tertiary': 'var(--media-kit-tertiary)',

  '--media-kit-widget-background-hover': 'var(--wb-color-neutral-50)',
  '--media-kit-widget-background-drag': 'var(--wb-color-orange-50)',
};

export const defaultFontName = 'Founders Grotesk (default)';

export const AVAILABLE_FONTS: Font[] = [
  {
    name: 'Anton',
    url: 'https://fonts.google.com/specimen/Anton',
    family: '"Anton", sans-serif',
  },
  {
    name: 'Barlow Condensed',
    url: 'https://fonts.google.com/specimen/Barlow+Condensed',
    family: '"Barlow Condensed", sans-serif',
  },
  {
    name: 'Caveat',
    url: 'https://fonts.google.com/specimen/Caveat',
    family: '"Caveat", cursive',
  },
  {
    name: 'Cormorant Garamond',
    url: 'https://fonts.google.com/specimen/Cormorant+Garamond',
    family: '"Cormorant Garamond", serif',
  },
  {
    name: 'DM Serif Display',
    url: 'https://fonts.google.com/specimen/DM+Serif+Display',
    family: '"DM Serif Display", serif',
  },
  {
    name: defaultFontName,
    url: 'https://fonts.google.com/specimen/Founders+Grotesk',
    family: '"Founders Grotesk", sans-serif',
  },
  {
    name: 'Indie Flower',
    url: 'https://fonts.google.com/specimen/Indie+Flower',
    family: '"Indie Flower", cursive',
  },
  {
    name: 'Inter',
    url: 'https://fonts.google.com/specimen/Inter',
    family: '"Inter", sans-serif',
  },
  {
    name: 'Josefin Sans',
    url: 'https://fonts.google.com/specimen/Josefin+Sans',
    family: '"Josefin Sans", sans-serif',
  },
  {
    name: 'Lato',
    url: 'https://fonts.google.com/specimen/Lato',
    family: '"Lato", sans-serif',
  },
  {
    name: 'Merriweather',
    url: 'https://fonts.google.com/specimen/Merriweather',
    family: '"Merriweather", serif',
  },
  {
    name: 'Montserrat',
    url: 'https://fonts.google.com/specimen/Montserrat',
    family: '"Montserrat", sans-serif',
  },
  {
    name: 'Noto Sans',
    url: 'https://fonts.google.com/noto/specimen/Noto+Sans',
    family: '"Noto Sans", sans-serif',
  },
  {
    name: 'Open Sans',
    url: 'https://fonts.google.com/specimen/Open+Sans',
    family: '"Open Sans", sans-serif',
  },
  {
    name: 'Oswald',
    url: 'https://fonts.google.com/specimen/Oswald',
    family: '"Oswald", sans-serif',
  },
  {
    name: 'Playfair Display',
    url: 'https://fonts.google.com/specimen/Playfair+Display',
    family: '"Playfair Display", serif',
  },
  {
    name: 'Poppins',
    url: 'https://fonts.google.com/specimen/Poppins',
    family: '"Poppins", sans-serif',
  },
  {
    name: 'PT Serif',
    url: 'https://fonts.google.com/specimen/PT+Serif',
    family: '"PT Serif", serif',
  },
  {
    name: 'Raleway',
    url: 'https://fonts.google.com/specimen/Raleway',
    family: '"Raleway", sans-serif',
  },
  {
    name: 'Roboto',
    url: 'https://fonts.google.com/specimen/Roboto',
    family: '"Roboto", sans-serif',
  },
  {
    name: 'Roboto Condensed',
    url: 'https://fonts.google.com/specimen/Roboto+Condensed',
    family: '"Roboto Condensed", sans-serif',
  },
  {
    name: 'Share Tech',
    url: 'https://fonts.google.com/specimen/Share+Tech',
    family: '"Share Tech", sans-serif',
  },
  {
    name: 'Slabo 27px',
    url: 'https://fonts.google.com/specimen/Slabo+27px',
    family: '"Slabo 27px", serif',
  },
];
